import './ProjectLayouts.scss';
import initPsw from '../../photoswipe/photoswipe';
import isSupportsWebp from '../../helpers/isSupportsWebp';

const init = () => {
  const images = document.querySelectorAll('[data-layout-img]');
  let imageSource;

  isSupportsWebp('lossy', (_, supportsWebp) => {
    imageSource = [].map.call(images, (elem) => ({
      src: `${elem.href}${supportsWebp ? '.webp' : ''}`,
      w: elem.dataset.w,
      h: elem.dataset.h,
    }));
  });

  [].forEach.call(images, (img, i) => {
    img.addEventListener('click', (event) => {
      event.preventDefault();
      initPsw(imageSource, i);
    });
  });
};

init();
